import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useSubmittalTrackerContext } from '../../../../SubmittalTrackerContext'
import { Submittal } from '../../../../SubmittalTrackerContext/types'

export function useCreateOptions():
  | CreateHeaderActionOptions<Submittal>
  | undefined {
  const {
    payItemGlobalId,
    metaFetching,
    createModal: { toggle },
  } = useSubmittalTrackerContext()
  if (payItemGlobalId) return undefined
  return {
    loading: metaFetching,
    entity: 'Submittal',
    permission: Permission.CreateConstructionAdminSubmittal,
    modal: { type: 'custom', toggle },
  }
}
